export function resolveApiBaseUrl(nodeEnvironment, configuredUrl) {
  if (nodeEnvironment === 'production') return '/api/';
  return configuredUrl || '/api/';
}

export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api/'
  : resolveApiBaseUrl(process.env.NODE_ENV, process.env.REACT_APP_API_URL);
